var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.124 10.7082H23.1968V10.6604H12.8367V15.2649H19.3422C18.3932 17.9453 15.8428 19.8693 12.8367 19.8693C9.02242 19.8693 5.92993 16.7769 5.92993 12.9627C5.92993 9.14841 9.02242 6.05592 12.8367 6.05592C14.5973 6.05592 16.1991 6.72011 17.4187 7.80505L20.6746 4.54909C18.6188 2.63305 15.8688 1.45142 12.8367 1.45142C6.47959 1.45142 1.32544 6.60557 1.32544 12.9627C1.32544 19.3197 6.47959 24.4739 12.8367 24.4739C19.1937 24.4739 24.3479 19.3197 24.3479 12.9627C24.3479 12.1908 24.2685 11.4374 24.124 10.7082Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.65234 7.60475L6.43436 10.3784C7.45771 7.84476 9.93608 6.05592 12.8364 6.05592C14.5969 6.05592 16.1987 6.72011 17.4183 7.80505L20.6743 4.54909C18.6184 2.63305 15.8684 1.45142 12.8364 1.45142C8.41487 1.45142 4.58048 3.94764 2.65234 7.60475Z",
    fill: "#FF3D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8364 24.4738C15.8098 24.4738 18.5116 23.336 20.5542 21.4855L16.9915 18.4707C15.7969 19.3792 14.3373 19.8706 12.8364 19.8693C9.84243 19.8693 7.30017 17.9602 6.34244 15.296L2.58862 18.1881C4.49374 21.9161 8.36266 24.4738 12.8364 24.4738Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1238 10.7087H23.1965V10.6609H12.8364V15.2653H19.342C18.888 16.541 18.0702 17.6558 16.9897 18.4719L16.9914 18.4706L20.5542 21.4854C20.3021 21.7146 24.3476 18.7187 24.3476 12.9632C24.3476 12.1913 24.2682 11.4379 24.1238 10.7087Z",
    fill: "#1976D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.918213 0.981445)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.2c1742f60b8a0a30ef23cbdbb233d397.svg";
export { ForwardRef as ReactComponent };